function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M557.326,128.382V539.394c0,27.125-.322,54.131,1.485,81.215,0.413,6.186.993,12.367,1.375,18.549,0.187,3.018.458,6.035,0.777,9.042,0.315,2.966,1.224,6.173,1.224,9.137,0.513,3.282.513,8.728,3.521,10.841,2.8,1.965,7.164,2.606,10.438,3.378a89.714,89.714,0,0,0,12.082,1.987,87.161,87.161,0,0,0,27.516-1.713c6.046-1.372,14.028-3.9,15.675-10.761,2-8.308,1.773-17.222,2.069-25.706,0.947-27.154.7-54.327,1.021-81.49q0.165-14,.334-27.99l0.549-46.175,0.438-36.77,0.229-19.247,0.014-1.144V128.382S599.46,95.355,557.326,128.382Z",
  transform: "translate(-556.554 -54.816)",
  fill: "none",
  stroke: "#62b6ff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M557.325,128.377a140.206,140.206,0,0,1,75.068-1.066q1.852,0.493,3.689,1.039",
  transform: "translate(-556.554 -54.816)",
  fill: "none",
  stroke: "#62b6ff",
  strokeMiterlimit: 10,
  strokeWidth: 1.5
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 38.08,
  cy: 296.239,
  r: 25.676,
  fill: "none",
  stroke: "#62b6ff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
});

var _ref4 = /*#__PURE__*/React.createElement("line", {
  x1: 16.127,
  y1: 309.563,
  x2: 61.981,
  y2: 286.86,
  fill: "none",
  stroke: "#62b6ff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 38.852,
  cy: 252.367,
  r: 1.773,
  fill: "#62b6ff"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 38.852,
  cy: 240.302,
  r: 1.773,
  fill: "#62b6ff"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M719.994,56.329a116.753,116.753,0,0,0-13.708-.763c-14.472.113-29.793,4.715-39.087,16.388-8.41,10.563-11.254,24.517-11.527,37.734q-0.042,2.007,0,4.015v452.42c0,22.3-2.388,47.546,14.544,64.883,10.237,10.483,24.581,14.489,38.819,15.41,12.768,0.826,25.983-1.91,38.612-3.534q17.7-2.278,35.38-4.8c19.709-2.854,43.484-3.921,58.386-19.07,2.016-2.05,3.792-4.339,5.949-6.24a20.8,20.8,0,0,0,3.457-3.313c1.679-2.365.78-7.114,0.78-10.092v-497.9c0-.838.056-1.7,0-2.537-0.206-3.156-3.331-5.854-5.188-8.272-2.835-3.691-5.718-7.43-9.433-10.233-4.988-3.765-11.168-5.6-17.315-6.733-21.2-3.9-42.513-7.414-63.753-11.161C744.138,60.447,732.051,57.658,719.994,56.329Z",
  transform: "translate(-556.554 -54.816)",
  fill: "none",
  stroke: "#62b6ff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M845.026,89.85l-34.7-6.73L763.31,74c-9.924-1.925-10.944,6.011-10.817,14.067,0.1,6.407.137,12.815,0.2,19.222l0.557,52.789,0.341,32.31V593.635c0,8.373-.361,16.758-0.2,25.128,0.166,8.6,10.056,7.1,16.05,6.187L845.9,613.886",
  transform: "translate(-556.554 -54.816)",
  fill: "none",
  stroke: "#62b6ff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M662.054,100.969v43.266s0.771,3.3,4.951,2.423c3.018-.634,3.643-3.6,3.7-6.293,0.265-13.857.052-27.735,0.052-41.594C670.752,92.787,662.054,96.437,662.054,100.969Z",
  transform: "translate(-556.554 -54.816)",
  fill: "none",
  stroke: "#62b6ff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
});

function SvgIlumaPrime({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 296.036,
    height: 619.884,
    viewBox: "0 0 296.036 619.884",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "iluma_prime") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIlumaPrime);
export default __webpack_public_path__ + "static/media/iluma_prime.591969f7106833ab7e918d1c0bf3a906.svg";
export { ForwardRef as ReactComponent };